import React from "react";
import { handleTelegramLinkClick, isTelegramUrl } from "../../utils/telegramLink";

type TelegramLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
};

export const TelegramLink = ({
  href,
  onClick,
  target = "_blank",
  rel = "noopener noreferrer",
  children,
  ...rest
}: TelegramLinkProps) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (event.defaultPrevented) return;
    handleTelegramLinkClick(event, href);
  };

  return (
    <a
      href={href}
      target={target}
      rel={rel}
      onClick={isTelegramUrl(href) ? handleClick : onClick}
      {...rest}
    >
      {children}
    </a>
  );
};
